import { setSnackbar } from "./SnackbarAction";
import { Alert, Typography, Snackbar } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

const CustomizedSnackbars = () => {
  const dispatch = useDispatch();

  const {
    snackbarOpen,
    snackbarType,
    snackbarMessage,
    snackbarAutoHideDuration,
    snackbarVertical,
    snackbarHorizontal,
  } = useSelector((state: any) => state.snackbar);

  const handleClose = (reason: any) => {
    if (reason === "clickaway") {
      return;
    }

    dispatch(
      setSnackbar(
        false,
        snackbarType,
        snackbarMessage,
        snackbarAutoHideDuration,
        snackbarVertical,
        snackbarHorizontal
      )
    );
  };

  let message = snackbarMessage?.replace(/\d/g, "").replace(/\./g, "");
  let errorCode = snackbarMessage?.replace(/\D/g, "") + ".";
  return (
    <div className={"width:100%"}>
      <Snackbar
        style={{
          height: "auto",
          lineHeight: "28px",
          padding: 24,
          whiteSpace: "pre-line",
        }}
        open={snackbarOpen}
        autoHideDuration={
          snackbarAutoHideDuration !== null ? snackbarAutoHideDuration : 900000
        }
        onClose={handleClose}
        anchorOrigin={{
          vertical: snackbarVertical,
          horizontal: snackbarHorizontal,
        }}
        sx={{
          position: "fixed",
          width: "70%",
        }}
      >
        <Alert
          elevation={6}
          variant="filled"
          onClose={handleClose}
          color={snackbarType}
        >
          {snackbarMessage?.match(/\d/) ? (
            <Typography fontSize="14px" sx={{ width: "max-content" }}>
              {message}
              <strong>{errorCode}</strong>
            </Typography>
          ) : (
            snackbarMessage
          )}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default CustomizedSnackbars;
